import { type VariantProps, cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'relative inline-flex min-h-11 items-center justify-center gap-2 rounded-md px-4 text-sm font-medium transition-[background-color,color,box-shadow,transform] duration-[var(--dur-fast)] active:translate-y-px disabled:pointer-events-none disabled:opacity-55',
  {
    variants: {
      variant: {
        primary: '[--btn-ink:var(--on-accent)] bg-accent-solid text-on-accent shadow-raised-sm hover:bg-accent-600 active:shadow-pressed',
        secondary: '[--btn-ink:var(--text)] border border-[var(--neu-edge)] bg-surface text-text shadow-raised-sm hover:bg-surface-raised hover:text-accent active:shadow-pressed',
        ghost: '[--btn-ink:var(--text-2)] text-text-2 hover:bg-surface-3 hover:text-text active:shadow-sunken',
        danger: '[--btn-ink:#ffffff] bg-danger-solid text-white shadow-raised-sm hover:brightness-110 active:shadow-pressed',
        link: '[--btn-ink:var(--accent)] min-h-0 px-0 text-accent underline-offset-4 hover:underline active:translate-y-0',
      },
      size: { md: '', sm: 'min-h-9 px-3 text-xs', block: 'w-full' },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);

export type ButtonVariant = NonNullable<VariantProps<typeof buttonVariants>['variant']>;
export type ButtonSize = NonNullable<VariantProps<typeof buttonVariants>['size']>;
